import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Container,
  Button,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import {
  APIgetDownloadRequest,
  APIupdateDownloadRequest,
  APIgetDownloadRequestFiles,
  APIdeleteDownloadRequest,
  APIremoveDownloadRequestFiles,
} from '../api/Downloads';

import { showModal } from '../actions';
import { showConfirmationModal } from '../actions/App';
import { clearFilesList } from '../actions/Files';

import DownloadRequestEditHeader from '../components/DownloadRequestEdit/Header';
import DownloadRequestEditTabContent from '../components/DownloadRequestEdit/TabContent';
import DownloadFilesHeader from '../components/DownloadFiles/Header';
import DownloadFilesList from '../components/DownloadFiles/List';

import {
  userCan,
  userIsAdmin,
} from '../helpers/Auth';
import { addFlashMessage } from '../helpers/FlashMessages';
import { getUserSetting } from '../helpers/Settings';
import { handleComponentParams, handleURLParams } from '../helpers/URLParams';

import Loading from '../components/Loading';
import ErrorBoundary from '../components/ErrorBoundary';
import NothingFound from '../components/NothingFound';
import GoBackToListButton from '../components/GoBackToListButton';

class DownloadRequestEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      downloadRequestId: null,
      downloadRequest: null,
      currentStatus: 'pending',
      selectedFileSizes: [],
      files: [],
      selectedFiles: [],
      filesTotal: 0,
      page: 1,
      perPage: getUserSetting('admin_per_page') || 20,
      orderBy: 'created_at',
      order: 'desc',
      errors: [],
      activeTab: '1',
      is404: false,
      loading: true,
      downloadFilesLoading: true,
      saving: false,
      timestamp: new Date(),
    };

    this.handleSave = this.handleSave.bind(this);
    this.handleChangeOrder = this.handleChangeOrder.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDownloadRequestFiles = this.handleDownloadRequestFiles.bind(this);
    this.handleShareRequestFiles = this.handleShareRequestFiles.bind(this);
    this.handleRemoveFiles = this.handleRemoveFiles.bind(this);
    this.handleSelectFile = this.handleSelectFile.bind(this);
    this.handleSelectAllFiles = this.handleSelectAllFiles.bind(this);
    this.loadMoreFiles = this.loadMoreFiles.bind(this);
  }

  componentDidMount() {
    const { clearFiles } = this.props;
    clearFiles();

    const { history, location } = this.props;
    const { orderBy, order } = this.state;
    const queryParams = new URLSearchParams(location.search);

    handleComponentParams(
      true,
      ['orderBy', 'order'],
      null,
      this.setState.bind(this),
      () => {
        this.loadDownload();
        this.loadDownloadFiles();
      },
      { orderBy: 'created_at', order: 'desc' },
    );

    if (!queryParams.get('orderBy')) {
      handleURLParams({ orderBy }, history, location.state);
    }

    if (!queryParams.get('order')) {
      handleURLParams({ order }, history, location.state);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { orderBy, order } = this.state;
    const { match } = this.props;
    const { downloadRequestId } = match.params;
    if (downloadRequestId &&
      (downloadRequestId !== prevProps.match.params.downloadRequestId ||
        prevState.orderBy !== orderBy ||
        prevState.order !== order)
    ) {
      handleComponentParams(
        false,
        ['orderBy', 'order'],
        prevProps,
        this.setState.bind(this),
        () => {
          this.loadDownload();
          this.loadDownloadFiles();
        },
        { orderBy: 'created_at', order: 'desc' },
      );
    }
  }

  componentWillUnmount() {
    const { clearFiles } = this.props;
    clearFiles();
  }

  getFileSize(fileSizeId) {
    const { fileSizes } = this.props;
    if (fileSizeId === 'original') {
      return {
        id: 'original',
      };
    }
    return fileSizes.find(fs => (`${fs.id}` === `${fileSizeId}`)) || null;
  }

  getDownloadButtonText() {
    const { intl } = this.props;
    const { selectedFiles } = this.state;

    if (selectedFiles.length === 0) {
      return intl.formatMessage({ defaultMessage: 'Select files to download' });
    }

    return intl.formatMessage({
      defaultMessage: 'Download {selectedFilesLength} selected {selectedFilesLength, plural, one {file} other {files}}',
    }, { selectedFilesLength: selectedFiles.length });
  }

  getShareButtonText() {
    const { intl } = this.props;
    const { selectedFiles } = this.state;

    if (selectedFiles.length === 0) {
      return intl.formatMessage({ defaultMessage: 'Select files to share' });
    }

    return intl.formatMessage({
      defaultMessage: 'Share {selectedFilesLength} selected {selectedFilesLength, plural, one {file} other {files}}',
    }, { selectedFilesLength: selectedFiles.length });
  }

  getSelectedFiles() {
    const {
      files,
      selectedFiles,
    } = this.state;

    const selectedFilesFull = [];
    selectedFiles.forEach((fileUuid) => {
      const file = files.find(f => (f.uuid === fileUuid));
      if (file) {
        selectedFilesFull.push(file);
      }
    });

    return selectedFilesFull;
  }

  loadDownload() {
    const { match } = this.props;
    const { downloadRequestId } = match.params;

    this.setState({
      downloadRequestId,
      loading: true,
    });

    APIgetDownloadRequest(downloadRequestId).then((response) => {
      const { data } = response;
      if (data) {
        this.setState({
          loading: false,
          downloadRequest: data,
          currentStatus: data.status,
          selectedFileSizes: data.file_sizes || [],
        });
      } else {
        this.setState({
          loading: false,
          is404: true,
        });
      }
    }).catch(() => {
      this.setState({
        loading: false,
        is404: true,
      });
    });
  }

  loadDownloadFiles(silent = false) {
    const { match } = this.props;
    const { downloadRequestId } = match.params;
    const {
      page,
      perPage,
      orderBy,
      order,
    } = this.state;

    if (!silent) {
      this.setState({ downloadFilesLoading: true });
    }

    APIgetDownloadRequestFiles(downloadRequestId, {
      page,
      per_page: perPage,
      orderby: orderBy,
      order,
    }).then((response) => {
      const { data } = response;
      if (data) {
        this.setState(prevState => ({
          downloadFilesLoading: false,
          files: prevState.files.concat(data.data),
          filesTotal: data.meta.total,
        }));
      }
    });
  }

  loadMoreFiles() {
    const {
      page,
      perPage,
      filesTotal,
      downloadFilesLoading,
    } = this.state;

    if (downloadFilesLoading || page * perPage >= filesTotal) {
      return;
    }

    this.setState({ page: page + 1 }, () => {
      this.loadDownloadFiles();
    });
  }

  handleChangeOrder(orderBy, order) {
    const { history, location } = this.props;
    handleURLParams({ orderBy, order, page: 1 }, history, location.state);

    this.setState({
      orderBy,
      order,
      page: 1,
      files: [],
    });
  }

  handleChangePage(page) {
    const { history, location } = this.props;
    handleURLParams({ page }, history, location.state);

    this.setState({ page });
  }

  resetState() {
    this.setState({
      saving: false,
      errors: [],
    });
  }

  handleError() {
    const { intl } = this.props;

    this.resetState();
    addFlashMessage({
      type: 'danger',
      text: intl.formatMessage({ defaultMessage: 'Something went wrong! Please try again.' }),
    });
  }

  saveDownload() {
    const { intl } = this.props;
    const {
      downloadRequestId,
      downloadRequest,
      selectedFileSizes,
    } = this.state;

    if (selectedFileSizes.length === 0) {
      this.setState({ errors: ['file_sizes'] });
      return;
    }

    this.setState({
      saving: true,
      errors: [],
    });

    if (downloadRequestId) {
      const fileSizes = [];
      selectedFileSizes.forEach((fileSizeObj) => {
        const fileSize = this.getFileSize(fileSizeObj.id);
        if (fileSize) {
          fileSizes.push({ id: fileSize.id });
        }
      });
      downloadRequest.file_sizes = fileSizes;
      APIupdateDownloadRequest({ downloadRequest }).then((response) => {
        const { data } = response;
        if (data) {
          this.setState({
            downloadRequest: data,
            currentStatus: data.status,
            selectedFileSizes: data.file_sizes || [],
          });
        }
        addFlashMessage({
          type: 'success',
          text: intl.formatMessage({ defaultMessage: 'The changes have been saved' }),
        });
        this.resetState();
      }).catch(() => {
        this.handleError();
      });
    }
  }

  handleSave() {
    this.saveDownload();
  }

  handleChange(e) {
    const {
      value,
      name,
      checked,
    } = e.target;

    if (name === 'file_sizes') {
      if (checked) {
        this.setState(prevState => ({
          selectedFileSizes: [...prevState.selectedFileSizes, this.getFileSize(value)],
        }));
      } else {
        this.setState(prevState => ({
          selectedFileSizes: prevState.selectedFileSizes.filter(sfs => (`${sfs.id}` !== `${value}`)),
        }));
      }
    }

    if (name === 'status') {
      this.setState(prevState => ({
        downloadRequest: { ...prevState.downloadRequest, status: value },
      }));
    }

    if (name === 'comment') {
      this.setState(prevState => ({
        downloadRequest: { ...prevState.downloadRequest, comment: value },
      }));
    }
  }

  handleDownloadRequestFiles(files) {
    const { downloadRequest } = this.state;
    const { handleDownloadFiles } = this.props;
    handleDownloadFiles(downloadRequest, files);
  }

  handleShareRequestFiles(files) {
    const { downloadRequest } = this.state;
    const { handleShareRequest } = this.props;
    handleShareRequest(downloadRequest, files);
  }

  removeFilesFromList(removedFiles) {
    this.setState(prevState => ({
      files: prevState.files.filter(f => (!removedFiles.includes(f.uuid))),
      filesTotal: prevState.filesTotal - removedFiles.length,
    }));
  }

  handleRemoveFiles(files) {
    const { downloadRequest } = this.state;
    const { handleRemoveFiles } = this.props;
    handleRemoveFiles(downloadRequest, files, () => this.removeFilesFromList(files));
  }

  handleSelectFile(e) {
    const {
      value,
      checked,
    } = e.target;

    if (checked) {
      this.setState(prevState => ({
        selectedFiles: [...prevState.selectedFiles, value],
      }));
    } else {
      this.setState(prevState => ({
        selectedFiles: prevState.selectedFiles.filter(sf => (sf !== value)),
      }));
    }
  }

  handleSelectAllFiles(e) {
    const { checked } = e.target;
    const { files } = this.state;

    if (checked) {
      this.setState({ selectedFiles: files.map(f => (f.uuid)) });
    } else {
      this.setState({ selectedFiles: [] });
    }
  }

  render() {
    const {
      downloadRequestId,
      downloadRequest,
      currentStatus,
      filesTotal,
      selectedFiles,
      is404,
      loading,
      downloadFilesLoading,
      page,
      perPage,
    } = this.state;
    const {
      intl,
      handleDeleteDownloadRequest,
      handleDownloadFiles,
      handleShareRequest,
    } = this.props;

    if (is404) {
      return (
        <NothingFound />
      );
    }

    return (
      <div className="main-content download-requests-content">
        <Container fluid>
          {loading ? (
            <Loading />
          ) : (
            <ErrorBoundary>
              <GoBackToListButton
                scope="download-requests"
              />
              <DownloadRequestEditHeader
                downloadRequest={downloadRequest}
              />
              <div className="content-wrapper">
                <ErrorBoundary>
                  <DownloadRequestEditTabContent
                    {...this.state}
                    handleChange={this.handleChange}
                    handleSave={this.handleSave}
                    handleDelete={handleDeleteDownloadRequest}
                    handleDownloadFiles={handleDownloadFiles}
                  />
                </ErrorBoundary>
              </div>
            </ErrorBoundary>
          )}
          {(!loading && downloadRequestId) && (
            <>
              <DownloadFilesHeader
                filesTotal={filesTotal}
                filesVisible={`${Math.min(page * perPage, filesTotal)}`}
                loading={downloadFilesLoading}
              />
              {(currentStatus === 'accepted' || userIsAdmin()) && (
                <div className="content-wrapper">
                  <Button
                    color="primary"
                    disabled={selectedFiles.length === 0}
                    onClick={() => {
                      this.handleDownloadRequestFiles(this.getSelectedFiles());
                    }}
                  >
                    {this.getDownloadButtonText()}
                  </Button>
                  {' '}
                  <Button
                    onClick={() => {
                      handleDownloadFiles(downloadRequest);
                    }}
                  >
                    {intl.formatMessage({ defaultMessage: 'Download all files' })}
                  </Button>
                  {userCan('share_download_requests') && (
                    <>
                      {' '}
                      <Button
                        color="primary"
                        disabled={selectedFiles.length === 0}
                        onClick={() => {
                          this.handleShareRequestFiles(this.getSelectedFiles());
                        }}
                      >
                        {this.getShareButtonText()}
                      </Button>
                      {' '}
                      <Button
                        onClick={() => {
                          handleShareRequest(downloadRequest);
                        }}
                      >
                        {intl.formatMessage({ defaultMessage: 'Share all files' })}
                      </Button>
                    </>
                  )}
                </div>
              )}
              <div className="content-wrapper">
                {filesTotal > 0 ? (
                  <ErrorBoundary>
                    <DownloadFilesList
                      {...this.state}
                      loadMore={this.loadMoreFiles}
                      handleChangeOrder={this.handleChangeOrder}
                      handleDownloadFiles={this.handleDownloadRequestFiles}
                      handleShareFiles={this.handleShareRequestFiles}
                      handleRemoveFiles={this.handleRemoveFiles}
                      handleSelectFile={this.handleSelectFile}
                      handleSelectAllFiles={this.handleSelectAllFiles}
                    />
                  </ErrorBoundary>
                ) : (
                  <div className="nothing-found-wrapper bottom">
                    <h3>{intl.formatMessage({ defaultMessage: 'No files found' })}</h3>
                  </div>
                )}
              </div>
              {downloadFilesLoading && (
                <Loading />
              )}
            </>
          )}
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fileSizes: state.App.fileSizes,
});

const mapDispatchToProps = (dispatch, props) => ({
  clearFiles: () => {
    dispatch(clearFilesList());
  },
  handleDeleteDownloadRequest: (request, callback) => {
    const { intl } = props;
    const modalParams = {
      title: intl.formatMessage({ defaultMessage: 'Are you sure?' }),
      text: intl.formatMessage({
        defaultMessage: `Are you sure you want to delete this download request? It will be permanently
          removed and the user will not be notified.`,
      }),
      onConfirm: () => (
        APIdeleteDownloadRequest(request.uuid).then(() => {
          callback();
        })
      ),
    };
    dispatch(showConfirmationModal(modalParams));
  },
  handleDownloadFiles: (request, files = []) => {
    dispatch(showModal('DownloadModal', {
      className: 'modal-download',
      files,
      requestUuid: request.uuid,
      availableFileSizes: request.file_sizes.map(fs => (`${fs.id}`)),
      backdrop: true,
    }));
  },
  handleShareRequest: (request, files = []) => {
    dispatch(showModal('ShareModal', {
      className: 'modal-share modal-share-file',
      request,
      files,
    }));
  },
  handleRemoveFiles: (request, files, callback) => {
    const { intl } = props;
    const modalParams = {
      title: intl.formatMessage({ defaultMessage: 'Are you sure?' }),
      text: intl.formatMessage({
        defaultMessage: `Are you sure you want to remove {filesLength, plural, one {this file} other {these files}}
          from the download request? {filesLength, plural, one {It} other {They}} will be permanently removed and
          the user will not be notified.`,
      }, { filesLength: files.length }),
      onConfirm: () => (
        APIremoveDownloadRequestFiles(request.uuid, files).then(() => {
          callback();
        })
      ),
    };
    dispatch(showConfirmationModal(modalParams));
  },
});

DownloadRequestEdit.propTypes = {
  intl: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  fileSizes: PropTypes.array.isRequired,
  clearFiles: PropTypes.func.isRequired,
  handleDeleteDownloadRequest: PropTypes.func.isRequired,
  handleDownloadFiles: PropTypes.func.isRequired,
  handleShareRequest: PropTypes.func.isRequired,
  handleRemoveFiles: PropTypes.func.isRequired,
};

export default withRouter(
  injectIntl(connect(mapStateToProps, mapDispatchToProps)(DownloadRequestEdit)),
);
